(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 8105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(7077);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9356:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/checked-green.7caf5014.png","height":256,"width":256,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAklEQVR42mMAAeNdNZpGu2oOGuys/mW+q/YXkAaxNYGYgUEfyAAKvgPi/za76/9L7yj7r72z6r/Gzsp3ijvKNRlMgToZthX/Z9hW+JNha/5/tz1N/z/++Pxz593j/xk2Jh5kYNiS/WvDrYP/r766+z94X8f/t98+/AeB5l3z/zMsy/zFwLA179fSazv/w8C/f//+l2+f8Z9hWvh/xQWFvxnsdjccZNiU/n/ZtV0/f/z6+b9qxyyQ5E+NRcX/mRfkHmbQAzrSDOhIwR2l/y221PxnmJ3yX2Fh4X/WBbnv+RbmaTGAgAnQm5a76g7q7q7+pb+x4hfjvNxDgovytQQX5TMAAAVulCklhibJAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 1186:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-dark-icon.af53ef32.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAATUlEQVR42j3NMQqAIABA0Td5raKgqNnw/kdQbHExQYg3/emTRYSBKJM0Jzg0CS7datHdELCpwz4rYFG9VrMcum3oToiaG1yahyL926R89ewWoHjqOHIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);




var Banner = function(param) {
    var title = param.title, currentPage = param.currentPage;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var goHome = function() {
        router.push("/");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "banner",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "banner-content",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "banner-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "breadcrumbs",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#",
                                    onClick: goHome,
                                    children: intl.messages.home
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: currentPage
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);


/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


var Popup = function(props) {
    return props.trigger ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "popup",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "popup-inner",
            children: props.children
        })
    }) : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (Popup);


/***/ }),

/***/ 7077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/banner.js
var banner = __webpack_require__(111);
// EXTERNAL MODULE: ./src/api/api.js + 1 modules
var api = __webpack_require__(977);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(1043);
// EXTERNAL MODULE: ./src/components/popup.js
var popup = __webpack_require__(2324);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/assets/images/contact-images/1.jpg
/* harmony default export */ var _1 = ({"src":"/_next/static/media/1.0925c824.jpg","height":960,"width":1440,"blurDataURL":"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoKCgoKCgsMDAsPEA4QDxYUExMUFiIYGhgaGCIzICUgICUgMy03LCksNy1RQDg4QFFeT0pPXnFlZXGPiI+7u/sBCgoKCgoKCwwMCw8QDhAPFhQTExQWIhgaGBoYIjMgJSAgJSAzLTcsKSw3LVFAODhAUV5PSk9ecWVlcY+Ij7u7+//CABEIAAUACAMBIgACEQEDEQH/xAAnAAEBAAAAAAAAAAAAAAAAAAAAAgEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAAAgB//xAAdEAACAgEFAAAAAAAAAAAAAAABAgMRAAQFEhMU/9oACAEBAAE/ANX6G3OaHvpWXmQFoXWf/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8Aj//EABcRAQADAAAAAAAAAAAAAAAAAAEAAhH/2gAIAQMBAT8Asuz/2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/simpleSlider.js







var SimpleSlider = function() {
    var settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "stylesheet",
                    type: "text/css",
                    charSet: "UTF-8",
                    href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: _1.src,
                        alt: ""
                    })
                })
            }))
        ]
    });
};
/* harmony default export */ var simpleSlider = (SimpleSlider);

// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(8499);
;// CONCATENATED MODULE: ./src/assets/images/icons/location-dark-icon.png
/* harmony default export */ var location_dark_icon = ({"src":"/_next/static/media/location-dark-icon.070e3965.png","height":64,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAUUlEQVR42iWIwQ2AMAwDLeDHCJ2EiZDg3TE6A0zQIViFIfpMT7FPUc5WpimgSc5N+SF0efjQHQLLvOgJocfDoTAYWbmetbstvKIBRW7auKpqm9WvGj1jqLKkAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/map.js







var AnyReactComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: location_dark_icon.src,
            className: "map-marker",
            alt: ""
        })
    });
};
var MapComponent = function() {
    var ref = (0,react.useState)(null), hostName = ref[0], setHostName = ref[1];
    var country = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (ref = state.main.data) === null || ref === void 0 ? void 0 : ref.country;
    });
    var countryCode = String(country);
    var windowHost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            window.location.hostname
                        ];
                    case 1:
                        data = _state.sent();
                        setHostName(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function windowHost() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        windowHost();
    }, []);
    var latitude = 40.174932731219684;
    var longitude = 44.519321801261896;
    if (hostName === "handle.ge") {
        if (countryCode === "1") {
            latitude = 40.174932731219684;
            longitude = 44.519321801261896;
        } else if (countryCode === "2") {
            latitude = 45.02582561894678;
            longitude = 39.035091167621616;
        } else {
            latitude = 41.69389094863286;
            longitude = 44.872500243356185;
        }
    } else if (hostName === "handle.brand.ru") {
        if (countryCode === "1") {
            latitude = 40.174932731219684;
            longitude = 44.519321801261896;
        } else if (countryCode === "3") {
            latitude = 41.69389094863286;
            longitude = 44.872500243356185;
        } else {
            latitude = 45.02582561894678;
            longitude = 39.035091167621616;
        }
    } else {
        if (countryCode === "2") {
            latitude = 45.02582561894678;
            longitude = 39.035091167621616;
        } else if (countryCode === "3") {
            latitude = 41.69389094863286;
            longitude = 44.872500243356185;
        } else {
            latitude = 40.174932731219684;
            longitude = 44.519321801261896;
        }
    }
    var defaultProps = {
        center: {
            lat: latitude,
            lng: longitude
        },
        zoom: 19
    };
    //AIzaSyCIPP0mRcHez9CDT9MpcbL0hLKdh2jlhGY
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
        bootstrapURLKeys: {
            key: "AIzaSyCY-hvCJQJg1ZuvqGDklFdiUfl32dYsoJA"
        },
        defaultCenter: defaultProps.center,
        defaultZoom: defaultProps.zoom,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnyReactComponent, {
            lat: latitude,
            lng: longitude
        })
    });
};
/* harmony default export */ var map = (MapComponent);

// EXTERNAL MODULE: ./src/assets/images/icons/location-white-icon.png
var location_white_icon = __webpack_require__(2298);
// EXTERNAL MODULE: ./src/assets/images/icons/envelop-white-icon.png
var envelop_white_icon = __webpack_require__(3737);
// EXTERNAL MODULE: ./src/assets/images/icons/phone-white-icon.png
var phone_white_icon = __webpack_require__(7837);
// EXTERNAL MODULE: ./src/assets/images/icons/close-dark-icon.png
var close_dark_icon = __webpack_require__(1186);
// EXTERNAL MODULE: ./src/assets/images/icons/checked-green.png
var checked_green = __webpack_require__(9356);
;// CONCATENATED MODULE: ./src/pages/contact.js




















var Contact = function() {
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)({
        name: "",
        email: "",
        description: "",
        phone: ""
    }), state = ref[0], setState = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), nameError = ref2[0], setNameError = ref2[1];
    var ref3 = (0,react.useState)(null), descriptionError = ref3[0], setDescriptionError = ref3[1];
    var ref4 = (0,react.useState)(null), phoneError = ref4[0], setPhoneError = ref4[1];
    var contactData = (0,es/* useSelector */.v9)(function(state) {
        return state.main.contacts;
    });
    var ref5 = (0,react.useState)(false), successSave = ref5[0], setSuccessSave = ref5[1];
    var ref6 = (0,react.useState)(null), hostName = ref6[0], setHostName = ref6[1];
    var country = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return (ref = state.main) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country;
    });
    var countryCode = String(country);
    var handleChange = function(evt) {
        var value = evt.target.value;
        setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, evt.target.name, value)));
    };
    var windowHost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            window.location.hostname
                        ];
                    case 1:
                        data = _state.sent();
                        setHostName(data);
                        return [
                            2
                        ];
                }
            });
        });
        return function windowHost() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        windowHost();
    }, []);
    var addContacts = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var name, email, phone, description, reData, addContactsData, e, ref;
            function validateEmail(email) {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            }
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        name = state.name;
                        email = state.email;
                        phone = state.phone;
                        description = state.description;
                        reData = validateEmail(email);
                        if (phone.length < 1) {
                            setPhoneError(intl.messages.phoneRequired);
                        } else {
                            setPhoneError("");
                        }
                        if (name.length < 1) {
                            setNameError(intl.messages.nameRequired);
                        } else {
                            setNameError("");
                        }
                        if (description.length < 1) {
                            setDescriptionError(intl.messages.messageRequired);
                        } else {
                            setDescriptionError("");
                        }
                        if (!reData) {
                            setError(intl.messages.emailRequired);
                        } else {
                            setError("");
                        }
                        if (!(name.length > 1 && reData && description.length > 1)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,api/* contacts_req */.uR)(state)
                        ];
                    case 2:
                        addContactsData = _state.sent();
                        if (addContactsData.success) {
                            setSuccessSave(!successSave);
                            setError("");
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (e.response.data) {
                            ;
                            setError((ref = e.response.data) === null || ref === void 0 ? void 0 : ref.message);
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function addContacts() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeSuccessPopup = function() {
        setSuccessSave(!successSave);
        setState({
            name: "",
            email: "",
            description: ""
        });
    };
    //   const meta = useMemo(() => {
    //     return {
    //       title: ,
    //       description:
    //         "Ցանկանում ես գնել բնական փայտից  կոնյակի տակառ, ժամացույց, շախմատ, նարդի, ձեռնափայտ և այլ հուշանվերներ | Իմացիր ավելին այստեղ",
    //     };
    //   }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: intl.messages.contactUs_title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: intl.messages.contactUs_desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "contact",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(banner/* default */.Z, {
                        title: intl.messages.contact,
                        currentPage: intl.messages.contactUs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "contact-content flex flex-ai-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-info",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex flex-ai-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "icon flex flex-ai-center flex-jc-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: phone_white_icon/* default.src */.Z.src,
                                                            alt: ""
                                                        })
                                                    }),
                                                    hostName === "handle.ge" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79965377770",
                                                                        children: "+79965377770"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79161110337",
                                                                        children: "+79161110337"
                                                                    })
                                                                ]
                                                            }),
                                                            (countryCode === "3" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995593152339",
                                                                        children: "+995593152339"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995595585866",
                                                                        children: "+995595585866"
                                                                    })
                                                                ]
                                                            }),
                                                            countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+37433585850",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone1
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:011585800",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone2
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    (hostName === "handle-brand.com" || hostName === "handle.am") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79965377770",
                                                                        children: "+79965377770"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79161110337",
                                                                        children: "+79161110337"
                                                                    })
                                                                ]
                                                            }),
                                                            countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995593152339",
                                                                        children: "+995593152339"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995595585866",
                                                                        children: "+995595585866"
                                                                    })
                                                                ]
                                                            }),
                                                            (countryCode === "0" || countryCode === "1") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+37433585850",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone1
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:011585800",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone2
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    hostName === "handle-brand.ru" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995593152339",
                                                                        children: "+995593152339"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+995595585866",
                                                                        children: "+995595585866"
                                                                    })
                                                                ]
                                                            }),
                                                            countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: intl.messages.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+37433585850",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone1
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:011585800",
                                                                        children: contactData === null || contactData === void 0 ? void 0 : contactData.phone2
                                                                    })
                                                                ]
                                                            }),
                                                            (countryCode === "0" || countryCode === "2") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79965377770",
                                                                        children: "+79965377770"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "tel:+79161110337",
                                                                        children: "+79161110337"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex flex-ai-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "icon flex flex-ai-center flex-jc-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: envelop_white_icon/* default.src */.Z.src,
                                                            alt: ""
                                                        })
                                                    }),
                                                    hostName === "handle.ge" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandarmenia@gmail.com",
                                                                children: "handlebrandarmenia@gmail.com"
                                                            }),
                                                            countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrand@mail.ru",
                                                                children: "handlebrand@mail.ru"
                                                            }),
                                                            (countryCode === "3" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandgeorgia@gmail.com",
                                                                children: "handlebrandgeorgia@gmail.com"
                                                            })
                                                        ]
                                                    }),
                                                    (hostName === "handle.am" || hostName === "handle-brand.com") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            (countryCode === "1" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandarmenia@gmail.com",
                                                                children: "handlebrandarmenia@gmail.com"
                                                            }),
                                                            countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrand@mail.ru",
                                                                children: "handlebrand@mail.ru"
                                                            }),
                                                            countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandgeorgia@gmail.com",
                                                                children: "handlebrandgeorgia@gmail.com"
                                                            })
                                                        ]
                                                    }),
                                                    hostName === "handle-brand.ru" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandarmenia@gmail.com",
                                                                children: "handlebrandarmenia@gmail.com"
                                                            }),
                                                            (countryCode === "2" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrand@mail.ru",
                                                                children: "handlebrand@mail.ru"
                                                            }),
                                                            countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "mailto:handlebrandgeorgia@gmail.com",
                                                                children: "handlebrandgeorgia@gmail.com"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex flex-ai-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "icon flex flex-ai-center flex-jc-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: location_white_icon/* default.src */.Z.src,
                                                            alt: ""
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: intl.messages.ourAddress
                                                            }),
                                                            hostName === "handle.ge" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: contactData === null || contactData === void 0 ? void 0 : contactData.address
                                                                        })
                                                                    }),
                                                                    countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "foo-address",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Turgeneva,+59,+Krasnodar,+Krasnodarskiy+kray,+Russia,+350000/@45.0458646,38.9547058,17z/data=!3m1!4b1!4m6!3m5!1s0x40f04f6e01c8337b:0x702ae763e791762f!8m2!3d45.0458608!4d38.9572807!16s%2Fg%2F11c290r9xr?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Г. Краснодар ул. Тургенева 59"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Tarasovskaya,+5%D0%B0,+Korolyov,+Moskovskaya+oblast',+Russia,+141068/@55.9479445,37.8322773,17z/data=!3m1!4b1!4m6!3m5!1s0x46b52e0cf9ee2cc9:0x70cd723f6ab7c9d7!8m2!3d55.9479415!4d37.8348522!16s%2Fg%2F11hj85w79l?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Московская область, г. Королев ул. Тарасовская 5A"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    (countryCode === "3" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/39b+Sesilia+Takaishvili+St,+T'bilisi+0163,+Georgia/@41.706164,44.8828398,17z/data=!3m1!4b1!4m6!3m5!1s0x40440d05fa7e73db:0x7d3e65c4a44607b5!8m2!3d41.70616!4d44.8854147!16s%2Fg%2F11wb_8gxy6?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: "Sesilia Takaishvili street 39b"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            hostName === "handle-brand.ru" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    countryCode === "1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: contactData === null || contactData === void 0 ? void 0 : contactData.address
                                                                        })
                                                                    }),
                                                                    (countryCode === "2" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "foo-address",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Turgeneva,+59,+Krasnodar,+Krasnodarskiy+kray,+Russia,+350000/@45.0458646,38.9547058,17z/data=!3m1!4b1!4m6!3m5!1s0x40f04f6e01c8337b:0x702ae763e791762f!8m2!3d45.0458608!4d38.9572807!16s%2Fg%2F11c290r9xr?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Г. Краснодар ул. Тургенева 59"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Tarasovskaya,+5%D0%B0,+Korolyov,+Moskovskaya+oblast',+Russia,+141068/@55.9479445,37.8322773,17z/data=!3m1!4b1!4m6!3m5!1s0x46b52e0cf9ee2cc9:0x70cd723f6ab7c9d7!8m2!3d55.9479415!4d37.8348522!16s%2Fg%2F11hj85w79l?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Московская область, г. Королев ул. Тарасовская 5A"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/39b+Sesilia+Takaishvili+St,+T'bilisi+0163,+Georgia/@41.706164,44.8828398,17z/data=!3m1!4b1!4m6!3m5!1s0x40440d05fa7e73db:0x7d3e65c4a44607b5!8m2!3d41.70616!4d44.8854147!16s%2Fg%2F11wb_8gxy6?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: "Sesilia Takaishvili street 39b"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            (hostName === "handle-brand.com" || hostName === "handle.am") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    (countryCode === "1" || countryCode === "0") && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/Handle+Brand/@40.1748637,44.5192301,21z/data=!4m5!3m4!1s0x406abcf14bc470ad:0xcc54b06955236c6e!8m2!3d40.1748391!4d44.5192709",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: contactData === null || contactData === void 0 ? void 0 : contactData.address
                                                                        })
                                                                    }),
                                                                    countryCode === "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "foo-address",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Turgeneva,+59,+Krasnodar,+Krasnodarskiy+kray,+Russia,+350000/@45.0458646,38.9547058,17z/data=!3m1!4b1!4m6!3m5!1s0x40f04f6e01c8337b:0x702ae763e791762f!8m2!3d45.0458608!4d38.9572807!16s%2Fg%2F11c290r9xr?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Г. Краснодар ул. Тургенева 59"
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                                href: "https://www.google.com/maps/place/Ulitsa+Tarasovskaya,+5%D0%B0,+Korolyov,+Moskovskaya+oblast',+Russia,+141068/@55.9479445,37.8322773,17z/data=!3m1!4b1!4m6!3m5!1s0x46b52e0cf9ee2cc9:0x70cd723f6ab7c9d7!8m2!3d55.9479415!4d37.8348522!16s%2Fg%2F11hj85w79l?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoJLDEwMjExNDU1SAFQAw%3D%3D",
                                                                                className: "flex flex-ai-center",
                                                                                target: "_blank",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                        src: location_white_icon/* default.src */.Z.src,
                                                                                        alt: ""
                                                                                    }),
                                                                                    "Московская область, г. Королев ул. Тарасовская 5A"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    countryCode === "3" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "foo-address",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "https://www.google.com/maps/place/39b+Sesilia+Takaishvili+St,+T'bilisi+0163,+Georgia/@41.706164,44.8828398,17z/data=!3m1!4b1!4m6!3m5!1s0x40440d05fa7e73db:0x7d3e65c4a44607b5!8m2!3d41.70616!4d44.8854147!16s%2Fg%2F11wb_8gxy6?entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D",
                                                                            className: "flex flex-ai-center",
                                                                            target: "_blank",
                                                                            children: "Sesilia Takaishvili street 39b"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "contact-image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simpleSlider, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "map",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(map, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "contact-form",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: intl.messages.contactWithUs
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            htmlFor: "name",
                                            className: "mr-20",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        intl.messages.yourName,
                                                        " *"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    id: "name",
                                                    name: "name",
                                                    value: state.name,
                                                    onChange: handleChange
                                                }),
                                                nameError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "error",
                                                    children: nameError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            htmlFor: "phone",
                                            className: "mr-20",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        intl.messages.yourPhone,
                                                        " *"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    id: "phone",
                                                    name: "phone",
                                                    value: state.phone,
                                                    onChange: handleChange
                                                }),
                                                phoneError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "error",
                                                    children: phoneError
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            htmlFor: "email",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        intl.messages.yourEmail,
                                                        " *"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    id: "email",
                                                    name: "email",
                                                    value: state.email,
                                                    onChange: handleChange
                                                }),
                                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "error",
                                                    children: error
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "message",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                intl.messages.yourMessage,
                                                " *"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            id: "message",
                                            cols: "30",
                                            rows: "10",
                                            name: "description",
                                            value: state.description,
                                            onChange: handleChange
                                        }),
                                        descriptionError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "error",
                                            children: descriptionError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex flex-jc-end",
                                    onClick: addContacts,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        children: intl.messages.send
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* default */.Z, {
                        trigger: successSave,
                        children: successSave && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: "close-button",
                                    onClick: closeSuccessPopup,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: close_dark_icon/* default.src */.Z.src,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "popup-body",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "popup-message",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: checked_green/* default.src */.Z.src,
                                                        alt: ""
                                                    }),
                                                    "Your message has been successfully sent."
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "popup-buttons",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: closeSuccessPopup,
                                                children: "Close"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contact = (Contact);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [55,876,774,888,179], function() { return __webpack_exec__(8105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);